import React from 'react';
import './Spinner.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullPage?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', fullPage = true }) => {
  const sizeClass = `spinner-${size}`;

  if (fullPage) {
    return (
      <div className="spinner-container">
        <div className={`spinner ${sizeClass}`}></div>
      </div>
    );
  }

  return <div className={`spinner ${sizeClass}`}></div>;
};

export default Spinner;
